"use strict";

exports.__esModule = true;
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _jquery = _interopRequireDefault(require("jquery"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function type(obj) {
  return Object.prototype.toString.call(obj);
}

;
var Authorization = null;
/**
 *
 */

var Request = /*#__PURE__*/function () {
  /**
   *
   */
  function Request() {
    var _this = this;

    this._xhr = void 0;
    this._success = void 0;
    this._error = void 0;
    this._complete = void 0;
    this._url = void 0;
    this._context = void 0;
    this._options = void 0;
    this._data = void 0;
    this._loading = void 0;
    this._response = void 0;
    this._type = "POST";
    this._headers = {};
    this._dataType = "JSON";
    this._async = true;
    this._jsonp = null;
    this._isSend = false;
    this._timer = 0;

    this.send = function () {
      _this._timer = setTimeout(_this._send);
      return _this;
    };

    this._send = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _headers, i, _options, _data, _headers2, _options2;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (type(_this._data) === "[object FormData]") {
                _headers = _jquery.default.extend({}, window.AJAX_HEADERS, _this._headers);

                for (i in _headers) {
                  // 表单提交删除content-type设置
                  if (i.toUpperCase() == "CONTENT-TYPE") {
                    delete _headers[i];
                  }
                }

                _options = {
                  context: _this,
                  url: _this._url,
                  data: _this._data,
                  headers: _headers,
                  xhrFields: _this._xhrFields || {
                    withCredentials: true
                  },
                  crossDomain: true,
                  scriptCharset: "utf-8",
                  global: !1,
                  type: "POST",
                  dataType: 'json',
                  processData: !1,
                  cache: true,
                  ifModified: true,
                  timeout: 30000,
                  async: true,
                  contentType: false,
                  success: _this.__success,
                  error: _this.__error,
                  complete: _this.__complete,
                  beforeSend: _this.__beforeSend,
                  xhr: function xhr() {
                    var myXhr = _jquery.default.ajaxSettings.xhr();

                    if (myXhr.upload) {
                      myXhr.upload.addEventListener('progress', function (e) {
                        if (e.lengthComputable) {
                          (0, _isFunction.default)(_this._progress) && _this._progress({
                            position: e.loaded,
                            total: e.total,
                            percentComplete: e.loaded / e.total
                          });
                        }
                      }, false);
                    }

                    return myXhr; //xhr对象返回给jQuery使用
                  }
                };
                _options = _jquery.default.extend({}, true, _options, _this._options);
                _this._xhr = _jquery.default.ajax(_options);
              } else {
                // console.log(this._type.toLocaleLowerCase());
                _data = _this._type.toLocaleLowerCase() === 'get' ? _this._data : JSON.stringify(_this._data || {}); // console.log(dencrypt(_data));
                // let sign = null;
                // if (this.sign && this._type == 'POST') {
                //     sign = this.sign(_data);
                //     if (sign) {
                //         this._headers['machine-sign'] = sign;
                //     }
                // }

                _headers2 = _jquery.default.extend({}, window.AJAX_HEADERS, _this._headers);
                _options2 = {
                  context: _this,
                  url: _this._url,
                  data: _data,
                  headers: _headers2,
                  xhrFields: _this._xhrFields || {
                    withCredentials: true
                  },
                  crossDomain: true,
                  scriptCharset: "utf-8",
                  global: !1,
                  type: _this._type,
                  dataType: _this._dataType,
                  jsonp: _this._jsonp,
                  processData: !0,
                  cache: true,
                  ifModified: true,
                  timeout: 30000,
                  async: _this._async,
                  contentType: window.AJAX_CONTENT_TYPE || 'application/json; charset=utf-8',
                  success: _this.__success,
                  error: _this.__error,
                  complete: _this.__complete,
                  beforeSend: _this.__beforeSend
                };
                _options2 = _jquery.default.extend({}, true, _options2, _this._options);
                _this._xhr = _jquery.default.ajax(_options2);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    this.url = function (url) {
      _this._url = url;
      return _this;
    };

    this.data = function (data) {
      _this._data = data;
      return _this;
    };

    this.options = function (options) {
      _this._options = options;
      return _this;
    };

    this.get = function (url) {
      _this._type = 'GET';
      _this._url = url;
      return _this;
    };

    this.jsonp = function (url) {
      _this._type = 'GET';
      _this._url = url;
      _this._dataType = "JSONP";
      _this._async = false;
      _this._jsonp = "callback";
      return _this;
    };

    this.dataType = function (val) {
      _this._dataType = val;
    };

    this.post = function (url) {
      _this._type = 'POST';
      _this._url = url;
      return _this;
    };

    this.put = function (url) {
      _this._type = 'PUT';
      _this._url = url;
      return _this;
    };

    this.patch = function (url) {
      _this._type = 'PATCH';
      _this._url = url;
      return _this;
    };

    this.delete = function (url) {
      _this._type = 'DELETE';
      _this._url = url;
      return _this;
    };

    this.headers = function (headers) {
      _this._headers = headers;
      return _this;
    };

    this.xhrFields = function (xhrFields) {
      _this._xhrFields = xhrFields;
      return _this;
    };

    this.context = function (context) {
      _this._context = context;
      return _this;
    };

    this.response = function (callback) {
      _this._response = callback;
      if (_this._isSend) return _this;

      _this.send();

      _this._isSend = true;
      return _this;
    };

    this.success = function (callback) {
      _this._success = callback;
      if (_this._isSend) return _this;

      _this.send();

      _this._isSend = true;
      return _this;
    };

    this.error = function (callback) {
      _this._error = callback;
      if (_this._isSend) return _this;

      _this.send();

      _this._isSend = true;
      return _this;
    };

    this.complete = function (callback) {
      _this._complete = callback;
      return _this;
    };

    this.loading = function (callback) {
      _this._loading = callback;
      return _this;
    };

    this.progress = function (callback) {
      _this._progress = callback;
      return _this;
    };

    this.stop = function () {
      _this._xhr && _this._xhr.abort();
    };

    this.then = function (resolve, reject) {
      _this.success(function (data) {
        resolve(data);
      }).error(function (e) {
        reject(e);
      });
    };
  }
  /**
   *
   * @returns {Request}
   */


  var _proto = Request.prototype;

  /**
   *
   * @param res
   * @param msg
   * @param ts
   * @private
   */
  _proto.__success = function __success(res, msg, ts) {
    // console.log(this)
    if ((0, _isFunction.default)(this._response)) {
      this._response(res, msg, ts);
    } else if (res.status != null) {
      if (res.status == 0 && !(res.data === null || typeof res.data === "undefined") && (0, _isFunction.default)(this._success)) {
        try {
          if (this._context) {
            this._success.call(this._context, res.data);
          } else {
            this._success(res.data);
          }
        } catch (ex) {
          console.error(ex);
        }
      } else {// console.log(res.status)
      }

      if (res.extend != null) {
        for (var key in res.extend) {
          try {
            window.appContext.emit('Response', key, res.extend[key]);
          } catch (ex) {
            console.error(ex);
          }
        }
      }

      if (res.msg != null) {
        try {
          window.appContext.emit('Response', 'msg', res.msg);
        } catch (ex) {
          console.error(ex);
        }
      }
    } else {
      for (var _key in res) {
        var val = res[_key];

        if (_key === 'callback') {
          if (val != null && (0, _isFunction.default)(this._success)) {
            try {
              if (this._context) {
                this._success.call(this._context, val);
              } else {
                this._success(val);
              }
            } catch (ex) {
              console.error(ex);
            }
          }
        } else {
          try {
            window.appContext.emit('Response', _key, val);
          } catch (ex) {
            console.error(ex);
          }
        }
      }
    }
  }
  /**
   *
   * @param ts
   * @param msg
   * @param errorThrown
   * @private
   */
  ;

  _proto.__error = function __error(ts, msg, errorThrown) {
    if (msg === 'abort') return;

    try {
      if ((0, _isFunction.default)(this._error)) {
        if (this._context) {
          this._error.call(this._context, msg);
        } else {
          this._error(new Error(msg + ' ' + ts.status + ' ' + errorThrown));
        }
      }
    } catch (ex) {
      console.error(ex);
    }
  }
  /**
   *
   * @param ts
   * @param msg
   * @private
   */
  ;

  _proto.__complete = function __complete(ts, msg) {
    // Authorization = this._xhr.getResponseHeader('authorization');
    // console.log(Authorization)
    try {
      (0, _isFunction.default)(this._loading) && this._loading(false);
    } catch (ex) {
      console.error(ex);
    }

    try {
      (0, _isFunction.default)(this._complete) && this._complete(msg);
    } catch (ex) {
      console.error(ex);
    }
  }
  /**
   *
   * @param ts
   * @private
   */
  ;

  _proto.__beforeSend = function __beforeSend(ts) {
    try {
      (0, _isFunction.default)(this._loading) && this._loading(true);
    } catch (ex) {
      console.error(ex);
    }
  }
  /**
   *
   * @param resolve
   * @param reject
   */
  ;

  _proto.catch = function _catch(reject) {
    this.error(reject);
  };

  return Request;
}();

var _default = Request;
exports.default = _default;
module.exports = exports.default;